import api from '@pray/shared/utils/api';

export interface EmailTemplateVariableList {
  category: string;
  name: string;
  description: string;
  example: string;
  syntax: string;
}

export interface EmailTemplatesPreviewReturn {
  templates: {
    [key: string]: string;
  };
  variableList: EmailTemplateVariableList[];
}

interface ApiResponse {
  data: {
    templates: {
      [key: string]: string;
    };
    // eslint-disable-next-line camelcase
    variable_list: EmailTemplateVariableList[];
  };
}

export async function getEmailTemplatesPreview(artistId: string): Promise<EmailTemplatesPreviewReturn> {
  const url = `/web/studio/artists/${artistId}/emails/templates`;
  const response = await api.executeGetRequest<ApiResponse>(url);

  return {
    templates: response.data?.data?.templates || {},
    variableList: response.data?.data?.variable_list || [],
  };
}
